import { MutationTree } from "vuex";
import { Referee } from "./../../models/referee.model";
import { RefereesState } from "./index";

export enum RefereesMutationTypes {
  SET_REFEREES = "SET_REFEREES"
}

export const mutations: MutationTree<RefereesState> = {
  [RefereesMutationTypes.SET_REFEREES](state, payload: Referee[]) {
    state.referees = payload;
  }
};
